// demo-container — wireframe skin module
// Token disposition: color tokens overridden to wf-* namespace; spacing/sizing pass-through

export const styles = `
  :host {
    display: block;
    border: 1px dashed var(--run-wf-border);
    border-radius: var(--run-demo-container-radius, var(--run-radius-semantic-card));
    overflow: hidden;
  }

  .preview-area {
    min-height: 64px;
    padding: var(--run-demo-container-preview-padding, var(--run-space-semantic-md));
    background: var(--run-wf-surface);
  }

  .preview-area[data-preview-padding="none"] {
    padding: 0;
  }

  .preview-area[data-preview-padding="sm"] {
    padding: var(--run-space-semantic-sm);
  }

  .preview-area[data-preview-padding="md"] {
    padding: var(--run-space-semantic-md);
  }

  .preview-area[data-preview-padding="lg"] {
    padding: var(--run-space-semantic-lg);
  }

  .preview-area[data-background="default"] {
    background: var(--run-wf-surface);
  }

  .preview-area[data-background="light"] {
    background: var(--run-wf-surface);
  }

  .preview-area[data-background="dark"] {
    background: var(--run-wf-surface);
  }

  .preview-area[data-background="checkerboard"] {
    background: var(--run-wf-surface);
  }

  .divider {
    height: 0;
    border-top: 1px dashed var(--run-wf-border);
  }

  .caption-wrapper {
    padding: var(--run-demo-container-preview-padding, var(--run-space-semantic-md));
    color: var(--run-wf-text);
    font-family: var(--run-wf-font-family);
    font-weight: 400;
    border-top: 1px dashed var(--run-wf-border);
  }

  run-code-display {
    display: block;
    border-top: 1px dashed var(--run-wf-border);
  }
`;

export function render(host) {
  const { background, previewPadding, caption, _hasCaptionSlot, _captionId } = host;

  const captionActive = (caption && caption.trim() !== '') || _hasCaptionSlot;

  const captionBlock = captionActive ? `
    <div class="caption-wrapper" part="caption" id="${_captionId}">
      <slot name="caption">
        <run-text size="sm" color="subtle">${caption || ''}</run-text>
      </slot>
    </div>
  ` : '';

  host.shadowRoot.innerHTML = `
    <div
      class="preview-area"
      part="preview"
      data-background="${background}"
      data-preview-padding="${previewPadding}"
    >
      <slot></slot>
    </div>
    ${captionBlock}
    <run-code-display></run-code-display>
  `;
}